import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { ProfileFieldsBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";
import { ContentProp } from "@/react/components/shared/BuilderUI/constants/PropCategories";
import { blockExists } from "../shared/blockExists";
import { FormContactEmailBlock as Block } from "./FormContactEmailBlock";
import { defaultData } from "./FormContactEmailBlockDefaultData";

export const FormContactEmailBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-email",
    size: 24,
  },
  meta: {
    name: "Email",
    version: 1,
    nameI18n: "builder_ui.block_type.form_contact_email",
    category: [ProfileFieldsBlock],
    isDisabled: blocks => blockExists(blocks, "FormContactEmailBlock"),
    props: {
      label: {
        prop: "other",
        type: "string",
        name: "Label",
        nameI18n: "builder_ui.prop_type.label",
        category: [ContentProp],
      },
      placeholder: {
        prop: "other",
        type: "string",
        name: "Placeholder",
        nameI18n: "builder_ui.prop_type.placeholder",
        category: [ContentProp],
      },
    },
  },
};
